import { Textarea } from "@frontend/components/ui/textarea"
import type { TextSchema } from "@frontend/pages/case-workspace/radiology/types"
import type { TextAnnotationState } from "@shared/lib/history-types"
import { useState } from "react"

interface TextModulePanelProps {
  schema: TextSchema
  moduleId: string
  activeSeriesId: string | null
  texts: TextAnnotationState[]
  onUpsertText: (text: TextAnnotationState) => void
}

export function TextModulePanel({ schema, moduleId, activeSeriesId, texts, onUpsertText }: TextModulePanelProps) {
  const targetSeriesId = schema.scope === "series" ? activeSeriesId : null
  const [generatedId] = useState(() => crypto.randomUUID())
  const existing = texts.find((t) => t.projectModuleId === moduleId && t.seriesId === targetSeriesId)
  const currentId = existing?.id ?? generatedId

  return (
    <div className="flex-1 overflow-auto p-3">
      <Textarea
        value={existing?.valueText ?? ""}
        placeholder={schema.placeholder ?? "Add notes"}
        maxLength={schema.max_length}
        rows={10}
        onChange={(e) =>
          onUpsertText({
            id: currentId,
            seriesId: targetSeriesId,
            projectModuleId: moduleId,
            valueText: e.target.value
          })
        }
      />
    </div>
  )
}
